export function IconOpenAI({ }: React.ComponentProps<"svg">) {
  return (
  <svg width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g transform="matrix(0.05333300307393073, 0, 0, 0.05333300307393073, -0.0021290001459455254, -0.00003800000558928929)">
          <rect
            x="20.832"
            y="135.869"
            width="417.486"
            height="226.07"
            style={{
              stroke: "rgb(0, 0, 0)",
              fill: "rgb(245, 125, 56)"
            }}
          />
          <g
            transform="matrix(0.098998, 0, 0, -0.100112, 58.57584, -1967.131226)"
            fill="#000000"
            stroke="none"
            style={{
              transformOrigin: "-60.4884px 1985.68px"
            }}>
            <path
              d="M 894.998 737.767 C 723.403 813.993 532.175 721.286 465.454 530.534 C 442.306 463.724 441.62 454.117 451.059 327.7 C 485.941 -123.751 674.554 -546.592 980.679 -864.299 C 1227.636 -1119.037 1536.043 -1296.088 1865.377 -1371.259 C 2037.722 -1410.184 2160.132 -1417.776 2390.744 -1404.682 C 2575.602 -1393.132 2598.878 -1389.153 2734.928 -1349.425 C 2902.162 -1299.063 3085.515 -1214.077 3225.831 -1120.955 C 3564.189 -896.56 3826.951 -545.844 3960.57 -139.839 C 4048.188 124.037 4072.11 404.936 4016.448 513.824 C 3982.623 579.778 3920.514 639.455 3854.236 672.367 C 3807.642 695.294 3786.143 698.83 3712.904 697.427 C 3633.599 694.756 3621.509 691.154 3562.659 656.156 C 3452.979 589.628 3414.763 516.986 3389.8 325.51 C 3338.424 -74.529 3121.811 -405.585 2793.133 -585.992 C 2626.27 -676.811 2474.064 -720.279 2291.055 -726.443 C 2058.264 -735.349 1852.649 -676.244 1643.457 -542.709 C 1597.658 -513.367 1533.883 -464.397 1501.263 -433.545 C 1262.525 -210.481 1141.824 43.183 1108.611 387.123 C 1094.334 535.741 1071.949 594.626 1003.372 664.737 C 979.111 689.48 930.152 721.911 894.998 737.767 Z M -42.944 1163.757 C -42.86 1594.257 539.819 2172.571 970.31 2175.47 C 1896.043 2181.703 2625.749 2183.469 3486.825 2178.125 C 3912.1 2175.486 4501.559 1607.65 4500.451 1183.806 C 4498.271 349.385 4501.07 -403.856 4503.069 -1255.866 C 4504.105 -1697.18 3932.363 -2322.275 3489.634 -2320.012 C 2633.434 -2315.636 1871.866 -2317.338 973.383 -2318.275 C 521.975 -2318.746 -44.221 -1753.201 -47.675 -1301.805 C -54.038 -470.333 -43.112 303.834 -42.944 1163.757 Z"
              style={{
                fill: "rgb(255, 255, 255)"
              }}
            />
          </g>
          <g transform="matrix(1, 0, 0, 1, -1.952494, 18.54615)">
            <path
              d="M 307.381 151.058 C 307.381 132.97674957528966 292.365078224575 118.319 273.842 118.319 C 255.318921775425 118.319 240.303 132.97674957528966 240.303 151.058 C 240.303 169.13925042471033 255.318921775425 183.797 273.842 183.797 C 292.365078224575 183.797 307.381 169.13925042471033 307.381 151.058 Z"
              style={{
                fill: "rgb(245, 125, 56)"
              }}
            />
            <circle
              cx="273.842"
              cy="151.058"
              r="32.739"
              style={{
                fill: "rgb(245, 125, 56)",
                stroke: "rgb(255, 255, 255)",
                strokeWidth: "1"
              }}
            />
            <circle
              cx="179.725"
              cy="151.823"
              r="32.739"
              style={{
                fill: "rgb(245, 125, 56)",
                stroke: "rgb(255, 255, 255)",
                strokeWidth: "1"
              }}
            />
          </g>
        </g>
      </svg>
  )
}

export type Prompt = {
  value: string
  label: string
  content: string
}

export type Model = {
  value: string
  label: string
  content?: string
  icon?: any
}

export type Message = {
  role: string
  content: string
}

export type language = {
  value: string
  label: string
}

export type Transcript = {
  text: string
  startTime: number
  endTime: number
}

export const languages: language[] = [
  { value: "en", label: "English" },
  { value: "es", label: "(Soon)" }
]

export const getPrompts = (summaryLanguage: string): Prompt[] => {
  return [
    {
      value: "default",
      label: "Default (Optimized)",
      content: `Here is the prompt (you can replace the default in the extension tab):
"Your output should use the following template and answer in ${summaryLanguage}:
## Summary
- Focus on the main points and conclusions
- Highlight only the most important numerical values with *number* format
- Include key statistical data, percentages, dates, and quantities when they are central to the topic
- Use highlighting sparingly for maximum impact

## Analogy
- Create a relatable comparison to help understand the main concept

## Notes
- List exactly 10 key takeaway points from the content
- Each point should be a complete informative statement
- These should be concise summary points, NOT definitions
- Focus on main ideas, findings, and conclusions
- Use _highlighting_ only for the most critical terms (maximum 2-3 per bullet point)

Requirements:
- You have been tasked with creating a concise summary of a YouTube video using its transcription to supply college student notes.
- Act like an expert in the subject the transcription covers.
- Create a short, relatable analogy from day-to-day life to explain the main concept.
- Use highlighting strategically - only for the most important terms and concepts
- Prioritize clarity and readability over extensive highlighting
- Avoid mentioning sponsorships or brand names.
- Ensure the summary, bullet points, and explanations fit within the 330-word limit while providing comprehensive understanding.
- Answer in ${summaryLanguage}. Use the text above: "`
    },
    {
      value: "minimal-highlight",
      label: "Minimal Highlight",
      content: `Create a summary in ${summaryLanguage} with the following structure:
## Summary
- Main points without excessive highlighting
- Include important numbers and data when relevant

## Key Insights
- 5-7 most important takeaways
- Use _highlighting_ only for 1-2 critical terms per point

## Context
- Brief analogy or real-world application

Keep it concise and readable, focusing on understanding rather than visual emphasis. Avoid sponsorships or brand names.`
    },
    {
      value: "structured-highlight",
      label: "Structured Highlight",
      content: `Summarize this content in ${summaryLanguage} using this approach:

## Main Summary
Provide an overview highlighting only the core concept and primary conclusion.

## Key Points
- List 8-10 important findings
- Highlight only _essential terms_ and *critical numbers*
- Maximum 1-2 highlights per bullet point

## Practical Application
Brief explanation of how this applies to real situations.

Focus on readability - use highlighting to guide attention, not overwhelm it. Avoid mentioning sponsorships or brand names.`
    },
    {
      value: "academic-style",
      label: "Academic Style",
      content: `Create academic-style notes in ${summaryLanguage}:

## Abstract
Brief overview of the main topic and conclusions.

## Key Findings
- 10 concise points covering the main content
- Minimal highlighting - only for _technical terms_ and *significant data*
- Prioritize clear, informative statements

## Implications
Short section on the practical significance or applications.

Use highlighting strategically to enhance comprehension, not for decoration. Avoid sponsorships or brand names. Keep within 330 words.`
    },
    {
      value: "clean-format",
      label: "Clean Format",
      content: `Create a clean, easy-to-read summary in ${summaryLanguage}:

## Overview
Main topic and key conclusions in 2-3 sentences.

## Important Points
- 8-10 clear, concise bullet points
- No excessive highlighting - only when absolutely necessary
- Focus on actionable insights and key learnings

## Bottom Line
One-sentence takeaway that captures the essence.

Prioritize clarity and comprehension over visual formatting. Avoid sponsorships or brand names.`
    },
    {
      value: "prompt-one",
      label: "Simple",
      content: `Give me a clear, well-organized summary of this video in ${summaryLanguage} with key points and main conclusions. Keep it concise and avoid mentioning any sponsorships or brand names.`
    }
  ];
}

export const models: Model[] = [
  {
    value: "default",
    label: "GPT-3.5",
    content: "gpt-4o-mini",
    icon: <IconOpenAI className="h-4 w-4 opacity-70" />
  },
  {
    value: "GPT-4",
    label: "GPT-4",
    content: "gpt-4-turbo",
    icon: <IconOpenAI className="h-4 w-4 opacity-70" />
  },
  {
    value: "GPT-4o mini",
    label: "GPT-4o mini",
    content: "gpt-4o-mini",
    icon: <IconOpenAI className="h-4 w-4 opacity-70" />
  }
]